import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProductType } from '../../components/product-type-context/ProductTypeContext';

const initialState = '';

const productSlice = createSlice({
    name: 'productType',
    initialState,
    reducers: {
        setProduct: (state, action: PayloadAction<ProductType>) => {
            return action.payload;
        },
    },
});

export const { setProduct } = productSlice.actions;
export default productSlice.reducer;
